import(/* webpackMode: "eager", webpackExports: ["OpportunitiesContainer"] */ "/vercel/path0/packages/app/src/features/opportunities/OpportunitiesContainer.tsx");
